import React from 'react'
import { Link } from 'react-router-dom'

import Script from 'dangerous-html/react'
import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './gdpr-legal.css'

const GDPRLegal = (props) => {
  return (
    <div className="gdpr-legal-container1">
      <Helmet>
        <title>GDPR-Legal - ClearPath Digital</title>
        <meta property="og:title" content="GDPR-Legal - ClearPath Digital" />
        <link
          rel="canonical"
          href="https://clearpathdigital.teleporthq.app/gdpr-legal"
        />
      </Helmet>
      <Navigation></Navigation>
      <section className="legal-hero">
        <div className="legal-hero-bg">
          <img
            alt="Cybersecurity and compliance background"
            src="https://images.pexels.com/photos/6963098/pexels-photo-6963098.jpeg?auto=compress&amp;cs=tinysrgb&amp;w=1500"
            className="legal-hero-img"
          />
          <div className="legal-hero-overlay"></div>
        </div>
        <div className="legal-hero-container">
          <div className="legal-hero-content">
            <span className="legal-hero-badge">GDPR &amp; EU COMPLIANCE</span>
            <h1 className="hero-title">Your Privacy, Our Priority</h1>
            <p className="hero-subtitle gdpr---legal-hero-subtitle">
              At ClearPath Digital, we build high-converting websites with a
              foundation of absolute legal transparency. This page outlines how
              we handle data in accordance with EU GDPR regulations.
            </p>
            <div className="legal-hero-actions">
              <a href="#contact">
                <div className="btn btn-primary">
                  <span>Privacy Inquiry</span>
                </div>
              </a>
            </div>
            <div className="legal-hero-meta">
              <div className="legal-meta-item">
                <span className="legal-meta-label">Data Controller</span>
                <span className="legal-meta-value">
                  ClearPath Digital Legal Dept.
                </span>
              </div>
              <div className="legal-meta-item">
                <span className="legal-meta-label">Jurisdiction</span>
                <span className="legal-meta-value">
                  European Union (France/Luxembourg)
                </span>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="legal-collection">
        <div className="legal-container">
          <div className="legal-header">
            <h2 className="section-title">
              Data Collection &amp; Legal Foundations
            </h2>
            <p className="section-content">
              We adhere to the principle of data minimisation, collecting only
              what is strictly necessary to deliver excellence.
            </p>
          </div>
          <div className="legal-accordion-group">
            <details open="true" className="legal-details">
              <summary className="legal-summary">
                <div className="legal-summary-inner">
                  <div className="legal-icon-box">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <path d="m16 11l2 2l4-4m-6 12v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"></path>
                        <circle r="4" cx="9" cy="7"></circle>
                      </g>
                    </svg>
                  </div>
                  <span>Personal Data We Collect</span>
                </div>
              </summary>
              <div className="legal-panel">
                <p className="section-content">
                  <span>
                    We collect contact details (name, email, phone) and
                    professional information (company name, website URL)
                    primarily through our strategy call and audit forms. This is
                    processed under the legal basis of
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="gdpr-legal-text13">
                    Contractual Necessity
                  </span>
                  <span>
                    {' '}
                    and
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="gdpr-legal-text15">Consent</span>
                  <span>.</span>
                </p>
              </div>
            </details>
            <details className="legal-details">
              <summary className="legal-summary">
                <div className="legal-summary-inner">
                  <div className="legal-icon-box">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <g
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      >
                        <rect
                          x="3"
                          y="11"
                          rx="2"
                          ry="2"
                          width="18"
                          height="11"
                        ></rect>
                        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
                      </g>
                    </svg>
                  </div>
                  <span>Purposes of Processing</span>
                </div>
              </summary>
              <div className="legal-panel">
                <p className="section-content">
                  <span>
                    Your data is used to provide tailored website strategies,
                    manage project communication, and fulfill legal obligations.
                    We do not sell your data to third parties. Our
                    <span
                      dangerouslySetInnerHTML={{
                        __html: ' ',
                      }}
                    />
                  </span>
                  <span className="gdpr-legal-text19">Legitimate Interest</span>
                  <span>
                    {' '}
                    includes improving our service quality and site security.
                  </span>
                </p>
              </div>
            </details>
            <details className="legal-details">
              <summary className="legal-summary">
                <div className="legal-summary-inner">
                  <div className="legal-icon-box">
                    <svg
                      width="24"
                      xmlns="http://www.w3.org/2000/svg"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path
                        d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      ></path>
                    </svg>
                  </div>
                  <span>Retention Periods</span>
                </div>
              </summary>
              <div className="legal-panel">
                <p className="section-content">
                  Client data is retained for the duration of the commercial
                  relationship plus 5 years to meet statutory limitation
                  periods. Marketing data (newsletter/leads) is kept for 3 years
                  from the last active contact or until consent is withdrawn.
                </p>
              </div>
            </details>
          </div>
        </div>
      </section>
      <section className="legal-cookies">
        <div className="legal-container">
          <div className="legal-header">
            <h2 className="section-title">Cookie &amp; Tracking Policy</h2>
            <p className="section-content">
              We use cookies to enhance your experience and analyze our
              performance without compromising your anonymity.
            </p>
          </div>
          <div className="legal-accordion-group">
            <details className="legal-details">
              <summary className="legal-summary">
                <div className="legal-summary-inner">
                  <span>Essential Cookies</span>
                </div>
              </summary>
              <div className="legal-panel">
                <p className="section-content">
                  These are necessary for the website to function. They include
                  session management and security features. These cannot be
                  disabled as they do not track personal behavior for marketing
                  purposes.
                </p>
              </div>
            </details>
            <details className="legal-details">
              <summary className="legal-summary">
                <div className="legal-summary-inner">
                  <span>Analytics &amp; Performance</span>
                </div>
              </summary>
              <div className="legal-panel">
                <p className="section-content">
                  We use tools like Plausible or anonymized Google Analytics to
                  understand how visitors interact with our content. These
                  cookies are only activated upon your explicit consent via our
                  cookie banner.
                </p>
              </div>
            </details>
            <details className="legal-details">
              <summary className="legal-summary">
                <div className="legal-summary-inner">
                  <span>Managing Your Consent</span>
                </div>
              </summary>
              <div className="legal-panel">
                <p className="section-content">
                  You can reset your preferences at any time by clicking the
                  &quot;Cookie Settings&quot; button in the footer or by
                  clearing your browser cache. We respect &quot;Do Not
                  Track&quot; (DNT) browser signals.
                </p>
                <button className="btn-outline btn btn-sm">
                  Reset Cookie Preferences
                </button>
              </div>
            </details>
          </div>
        </div>
      </section>
      <section className="gdpr-legal-thq-legal-rights-elm legal-rights"></section>
      <section className="legal-security">
        <div className="legal-container">
          <div className="legal-header">
            <h2 className="section-title">Security &amp; Incident Response</h2>
            <p className="section-content">
              We implement robust technical and organizational measures to
              safeguard your information from unauthorized access.
            </p>
          </div>
          <div className="legal-accordion-group">
            <details className="legal-details">
              <summary className="legal-summary">
                <div className="legal-summary-inner">
                  <span>Technical Safeguards</span>
                </div>
              </summary>
              <div className="legal-panel">
                <p className="section-content">
                  Our infrastructure uses end-to-end encryption (TLS 1.3),
                  regular vulnerability scanning, and strict access control
                  (MFA). All code is reviewed for security best practices before
                  deployment.
                </p>
              </div>
            </details>
            <details className="legal-details">
              <summary className="legal-summary">
                <div className="legal-summary-inner">
                  <span>Breach Notification Procedure</span>
                </div>
              </summary>
              <div className="legal-panel">
                <p className="section-content">
                  In the unlikely event of a data breach, we follow a strict
                  protocol: detection, containment, assessment, and
                  notification. We notify the relevant supervisory authority
                  (CNIL/CNPD) within 72 hours and affected individuals without
                  undue delay if the risk is high.
                </p>
              </div>
            </details>
          </div>
        </div>
      </section>
      <section id="contact" className="legal-contact">
        <div className="legal-container">
          <div className="legal-contact-split">
            <div className="legal-contact-info">
              <h2 className="section-title">Privacy Inquiries</h2>
              <p className="section-content">
                Have questions about your data? Our dedicated compliance team is
                ready to assist you. We aim to provide clarity and transparency
                in every interaction.
              </p>
              <div className="legal-contact-details">
                <div className="legal-contact-card">
                  <strong>Address</strong>
                  <span>ClearPath Digital Legal Dept.</span>
                </div>
                <div className="legal-contact-card">
                  <strong>Email</strong>
                  <span>igor.d&apos;adhemar@clearpathdigital.co</span>
                </div>
              </div>
            </div>
            <div className="legal-contact-form-box">
              <form
                action="/submit-privacy"
                method="POST"
                data-form-id="10e208db-373a-4329-8f39-bcdc2756a771"
                className="legal-form"
              >
                <div className="legal-form-grid">
                  <div className="legal-form-field">
                    <label htmlFor="name">Full Name</label>
                    <input
                      type="text"
                      id="name"
                      name="true"
                      required="true"
                      placeholder="John Doe"
                      data-form-field-id="name"
                    />
                  </div>
                  <div className="legal-form-field">
                    <label htmlFor="email">Email Address</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      required="true"
                      placeholder="john@company.com"
                      data-form-field-id="email"
                    />
                  </div>
                </div>
                <div className="legal-form-field">
                  <label htmlFor="request-type">Request Type</label>
                  <select
                    id="request-type"
                    name="request-type"
                    required="true"
                    data-form-field-id="request-type"
                  >
                    <option value="true">Select a request type...</option>
                    <option value="access">Data Access Request (DSAR)</option>
                    <option value="erasure">Right to Erasure</option>
                    <option value="correction">Data Correction</option>
                    <option value="other">General Inquiry</option>
                  </select>
                </div>
                <div className="legal-form-field">
                  <label htmlFor="message">Message</label>
                  <textarea
                    id="message"
                    name="message"
                    rows="4"
                    required="true"
                    placeholder="Please describe your request in detail..."
                    data-form-field-id="message"
                  ></textarea>
                </div>
                <div className="legal-form-consent">
                  <input
                    type="checkbox"
                    id="consent"
                    name="consent"
                    required="true"
                    data-form-field-id="consent"
                  />
                  <label htmlFor="consent">
                    I consent to the processing of this data for the purpose of
                    resolving my privacy inquiry.
                  </label>
                </div>
                <button
                  id="thq_button_f6S7"
                  name="button"
                  type="submit"
                  data-form-field-id="thq_button_f6S7"
                  className="btn btn-primary btn-lg"
                >
                  Submit Request
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>
      <section id="audit" className="legal-resources">
        <div className="legal-container">
          <div className="legal-header">
            <h2 className="section-title">Legal Resources &amp; Downloads</h2>
            <p className="section-content">
              Access our full legal framework or request specialized documents
              for your business needs.
            </p>
          </div>
          <div className="legal-resource-grid">
            <div className="legal-resource-card">
              <div className="legal-resource-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 15V3m9 12v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <path d="m7 10l5 5l5-5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Privacy Policy (PDF)</h3>
              <p className="section-content">
                The complete, unabridged version of our data handling policies.
              </p>
              <a href="#">
                <div className="btn btn-link">
                  <span>Download Full PDF</span>
                </div>
              </a>
            </div>
            <div className="legal-resource-card">
              <div className="legal-resource-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 15V3m9 12v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <path d="m7 10l5 5l5-5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Cookie Policy</h3>
              <p className="section-content">
                Detailed list of all cookies, their providers, and durations.
              </p>
              <a href="#">
                <div className="btn btn-link">
                  <span>Download Full PDF</span>
                </div>
              </a>
            </div>
            <div className="legal-resource-card">
              <div className="legal-resource-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M12 15V3m9 12v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                    <path d="m7 10l5 5l5-5"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">DPA Template</h3>
              <p className="section-content">
                Standard Data Processing Agreement for our enterprise clients.
              </p>
              <a href="#">
                <div className="btn btn-link">
                  <span>Request Template</span>
                </div>
              </a>
            </div>
            <div className="legal-resource-card">
              <div className="legal-resource-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M20 13c0 5-3.5 7.5-7.66 8.95a1 1 0 0 1-.67-.01C7.5 20.5 4 18 4 13V6a1 1 0 0 1 1-1c2 0 4.5-1.2 6.24-2.72a1.17 1.17 0 0 1 1.52 0C14.51 3.81 17 5 19 5a1 1 0 0 1 1 1z"></path>
                    <path d="m9 12l2 2l4-4"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Legal Notices</h3>
              <p className="section-content">
                Impressum and corporate registration details for EU
                transparency.
              </p>
              <a href="#">
                <div className="btn btn-link">
                  <span>View Online</span>
                </div>
              </a>
            </div>
            <div className="legal-resource-card highlight">
              <div className="legal-resource-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <circle r="1" cx="12" cy="16"></circle>
                    <rect x="3" y="10" rx="2" width="18" height="12"></rect>
                    <path d="M7 10V7a5 5 0 0 1 10 0v3"></path>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Privacy Audit</h3>
              <p className="section-content">
                Request a professional audit of your own website&apos;s
                compliance.
              </p>
              <Link to="/contact-book-a-call">
                <div className="gdpr-legal-thq-btn-elm8 btn-accent btn">
                  <span>Request Audit</span>
                </div>
              </Link>
            </div>
            <div className="legal-resource-card">
              <div className="legal-resource-icon">
                <svg
                  width="24"
                  xmlns="http://www.w3.org/2000/svg"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <g
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  >
                    <path d="M18 6V4a2 2 0 1 0-4 0v2m6 9v6a1 1 0 0 1-1 1H6.5a1 1 0 0 1 0-5H20"></path>
                    <path d="M4 19.5v-15A2.5 2.5 0 0 1 6.5 2H10"></path>
                    <rect x="12" y="6" rx="1" width="8" height="5"></rect>
                  </g>
                </svg>
              </div>
              <h3 className="section-subtitle">Terms of Service</h3>
              <p className="section-content">
                The rules governing the use of our website and services.
              </p>
              <a href="#">
                <div className="btn btn-link">
                  <span>Read Terms</span>
                </div>
              </a>
            </div>
          </div>
        </div>
      </section>
      <div className="gdpr-legal-container2">
        <div className="gdpr-legal-container3">
          <Script
            html={`<script defer data-name="legal-page-interactions">
(function(){
  // Handle cookie preference reset button
  const resetCookieBtn = document.querySelector('.legal-cookies .btn-outline');
  if (resetCookieBtn) {
    resetCookieBtn.addEventListener('click', () => {
      // In a real implementation, this would trigger the cookie consent manager
      alert('Cookie preferences have been reset. The consent banner will appear on your next page load.');
      localStorage.removeItem('cookie-consent-given');
      window.location.reload();
    });
  }

  // Simple form feedback
  const privacyForm = document.querySelector('.legal-form');
  if (privacyForm) {
    privacyForm.addEventListener('submit', (e) => {
      // Note: Native submission handles the POST, this is just for UX feedback
      const submitBtn = privacyForm.querySelector('button[type="submit"]');
      submitBtn.disabled = true;
      submitBtn.textContent = 'Processing...';
      
      // We let the native browser submission proceed unless we wanted a SPA-style feedback
      // For this demo, we'll just show the state change
    });
  }

  // Smooth scroll for internal links
  document.querySelectorAll('a[href^="#"]').forEach(anchor => {
    anchor.addEventListener('click', function (e) {
      e.preventDefault();
      const target = document.querySelector(this.getAttribute('href'));
      if (target) {
        target.scrollIntoView({
          behavior: 'smooth'
        });
      }
    });
  });

  // Accordion auto-close behavior (optional enhancement)
  const allAccordions = document.querySelectorAll('.legal-details');
  allAccordions.forEach(acc => {
    acc.addEventListener('toggle', () => {
      if (acc.open) {
        allAccordions.forEach(other => {
          if (other !== acc && other.open) {
            other.open = false;
          }
        });
      }
    });
  });
})()
</script>`}
          ></Script>
        </div>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default GDPRLegal
